// src/context/PageThemeContext.js
import React, { createContext, useContext } from 'react';

// Erstelle den Context mit einem Standardwert (z.B. null oder eine Standardfarbe)
// Der Standardwert wird verwendet, wenn eine Komponente den Context konsumiert,
// aber kein Provider darüber im Baum ist.
const PageThemeContext = createContext(null);

// Ein Hook, der die Verwendung des Contexts vereinfacht und Fehler abfängt
export const usePageTheme = () => {
  const context = useContext(PageThemeContext);
  if (context === undefined) {
    throw new Error('usePageTheme must be used within a PageThemeContextProvider');
  }
  return context;
};

// Der Provider, der die Daten für den Context bereitstellt
export const PageThemeContextProvider = ({ children, overallPageBackgroundColor }) => {
  const themeValue = {
    overallPageBackgroundColor: overallPageBackgroundColor,
    // Hier könnten Sie weitere globale Theme-bezogene Werte hinzufügen
    // z.B. overallPageTextColor, brandColor, etc.
  };

  return (
    <PageThemeContext.Provider value={themeValue}>
      {children}
    </PageThemeContext.Provider>
  );
};